module.exports = __webpack_public_path__ + "public/SiteIcons/charities.png?533ba303";